import script from "./StudentResultComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentResultComponent.vue?vue&type=script&setup=true&lang=js"

import "./StudentResultComponent.vue?vue&type=style&index=0&id=91a91df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a91df6"]])

export default __exports__